module.exports = __webpack_public_path__ + "img/united.9f35d4c0.png";